function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".lk-sf .a{fill:#00abe8;fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M718.043,279.584H714.5v-5.127c0-1.342-.555-2.258-1.774-2.258a1.789,1.789,0,0,0-1.693,1.214,2.257,2.257,0,0,0-.076.81v5.361h-3.513s.045-9.082,0-9.907h3.513v1.555a3.211,3.211,0,0,1,3.121-1.65c2.222,0,3.968,1.425,3.968,4.494v5.509Zm-14.154-11.147h-.023A1.729,1.729,0,0,1,702,266.72a1.907,1.907,0,1,1,1.888,1.717Zm-1.484,1.239h3.127v9.907H702.4v-9.907Z",
  transform: "translate(-702 -265)"
});

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "lk-sf",
    width: 16.043,
    height: 14.584,
    viewBox: "0 0 16.043 14.584",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.f58468a5.svg";
export { ForwardRef as ReactComponent };